/* tslint:disable */

/**
 */
export class Role {
    name?: string;
    display_name?: string;
}
